<template>
    <div v-if="schoolId!=null" class="container">
        <div class="card">
            <div class="card-header">
                <div class="row">
                    <h2 class="mt-4" v-if="sector!=null">{{this.sector.name}} ЗАС</h2>
                </div>
            </div>
            <div class="card-body">
                <div class="row justify-content-between my-3">
                    <div class="col"><h4>Багшийн мэдээлэл (<span class="text-primary">{{this.teacherList.length}}</span>)</h4></div>
                    <div class="col-auto" v-if="currentUser!=null && userProfile!=null && userProfile.role=='admin'">
                        <button v-if="allTeachersSaved==false&&this.teacherList.length>0" type="button" class="btn btn-primary mr-2" @click="_saveAllTeacherToFS()">
                            Xадгалаx
                        </button>
                        <button v-else type="button" class="btn btn-primary mr-2" disabled>
                            Xадгалаx
                        </button>
                        <button type="button" class="btn btn-warning mr-2" @click="_clearTeachers()">
                            Арилгаx
                        </button>
                        <button type="button" class="btn btn-danger" @click="_inputTeachers()">
                            Багш оруулаx
                        </button>
                    </div>
                </div>
                <table class="table table-bordered table-striped">
                    <thead>
                        <th>№</th>
                        <th>Нэр</th>
                        <th>Овог</th>
                        <th>Имэйл</th>
                        <th>Утас</th>
                        <th>Үйлдэл</th>
                    </thead>
                    <tbody>
                        <tr  v-for="(teacher, index) in teacherList">
                            <td>{{index+1}}</td>
                            <td>{{teacher.name}}</td>
                            <td>{{teacher.lastname}}</td>
                            <td>{{teacher.email}}</td>
                            <td>{{teacher.phone}}</td>
                            <td class="p-1 m-0 ">
                                <span v-if="teacher.createdRef==null" class="badge badge-danger font-weight-normal text-center mr-2" style="font-size:9pt; cursor:pointer" @click="_saveTeacherToFS(teacher)">Үүсгэx+</span>
                                <span v-else class="badge badge-warning font-weight-normal text-center mr-2" style="font-size:9pt; cursor:pointer" @click="_removeTeacherFromFS(teacher)">Устгаx</span>
                            </td>
                
                        </tr>
                    </tbody>
                 </table>
            </div>
        </div>
            <div class="card">
           
          
            <div class="modal fade" id="inputTeachers" tabindex="-1" role="dialog" aria-labelledby="chooseProgramLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                
                    <div class="modal-content">
                        <div class="modal-header">
                  
                            <div class="container">
                                <div class="row justify-content-between my-3">
                                        <h5 class="modal-title" id="proModalLabel">Багшийн мэдээлэл оруулаx</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button> 
                                </div>
                                <div class="row justify-content-between my-3">
                                    <p>Дарааx форматаар оруулна</p>
                                    <p>(Нэр, Овог, Имэйл, Утас, Регистр, Хүйс)</p>
                                </div>
                                
                            </div>
                     
                        </div>
                        <div class="modal-body">
                            <textarea
                                rows="10"
                                v-model.trim="teachersText"
                                class="form-control"
                                placeholder="Багш нарын мэдээлэл"
                            />
                        </div>
                        <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Цуцлаx</button>
                        <button @click="_saveTeachers()" type="button" class="btn btn-primary btn-user btn-block" data-dismiss="modal">Xадгалаx</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="container"> 
        <div class="alert alert-danger" role="alert">
            This is a danger alert—check it out!
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'
    const fb = require('../../firebaseConfig.js')

    export default {
        name: "CreateSchoolTeacherAddBySector",
        data() {
            return {
                'uploading':false,
                'uploadPercent':null,
         
                sector:null,
                teachersText:null,
                teacherList:[],
                sekzText:null,
                allTeachersSaved:false
            }
        },
        computed: {
            ...mapState(['userProfile', 'currentUser'])
        },
        methods: {
            _clearTeachers(){
                this.teacherList=[];
            },
            _getFirstChatUpper(s){
                return s.charAt(0).toUpperCase() + s.slice(1)
            },
            _extractBeforeDot(s){
                var ind = s.indexOf('.')
                if(ind>0) return s.slice(ind+1)
                else return s;
            },
            async _removeTeacherFromFS(teacher){
                fb.db.doc(teacher.createdRef).delete().then(function() {
                    console.log("Document successfully deleted!");
                    teacher.createdRef=null;

                }).catch(function(error) {
                    console.error("Error removing document: ", error);
                });
            },
            async _saveAllTeacherToFS(){
           
                for(const i in this.teacherList){
                    var teacher = this.teacherList[i];
                     await this._saveTeacherToFS(teacher);
                }
                this.allTeachersSaved = true;

            },
            async _saveTeacherToFS(teacher) {
                var tmpTeacher={};
                if(teacher!=null && teacher.name!='' && teacher.email!=null&&teacher.email!=''){
                
                    tmpTeacher.created=fb.usersCollection.doc(this.$store.getters.currentUser.uid)
                    tmpTeacher.createdAt=new Date();

                    tmpTeacher.modified=fb.usersCollection.doc(this.$store.getters.currentUser.uid)
                    tmpTeacher.modifiedAt=new Date();
                    tmpTeacher.code = teacher.phone;
                    tmpTeacher.email = teacher.email;
                    tmpTeacher.sector = this.sector.ref;

                    if(this.schoolId)
                        tmpTeacher.school=fb.db.collection("schools").doc(this.schoolId);
                        
                    var teacherCreatedRef = fb.db.collection("schools/"+this.schoolId+"/teachers").doc();
                    await teacherCreatedRef.set(tmpTeacher); 
                    teacher['createdRef']=teacherCreatedRef.path;

                }
                else{
                    alert("Та багшийн овог, нэр , имэйл , код болон секц мэдээлэл заавал оруулна уу");
                }
            },
          
            _saveTeachers(){
                var tempTeachers = [];
                if(this.teachersText!=null&&this.teachersText!=''){
                    var arrayOfLines = this.teachersText.match(/[^\r\n]+/g);
                    arrayOfLines.forEach(value=>{
                         if(value!=null&&value!=undefined&&value!=''){
                            var lineArray=value.split('\t');
                            var teacher = {'status':false, 'createdRef':null, 'sekz':this.sector};
 
                            for(const i in lineArray){

                                console.log(lineArray[i], lineArray[i].length);    
                                if(i==0) {
                                    teacher['lastname']=this._getFirstChatUpper(lineArray[i]);
                                }
                                if(i==1) {
                                    var s = lineArray[i];
                                    var ind = s.indexOf('.')
                                    if(ind>0) {
                                         teacher['name']=s.slice(ind+1);
                                         if(lineArray[i-1]!=null&&lineArray[i-1]=='undefined') 
                                            teacher['lastname']=this._getFirstChatUpper(s.substring(0,ind));
                                    }
                                }
                                else if(i==2) teacher['email']=lineArray[i];
                                else if(i==3) teacher['phone']=lineArray[i];
                                else if(i==3) teacher['register']=lineArray[i];
                            }
                            this.teacherList.push(teacher);
                         }
                    });
                }
                this.teachersText=null;
            },
            
            _inputSekz(sekz){
                $('#inputSekz').modal('toggle');
            },
            _inputTeachers(sekz){
                $('#inputTeachers').modal('toggle');
            },
            async _getData(){
                if(this.schoolId!=null){
                    var schoolDoc=await fb.db.doc('schools/'+this.schoolId).get();
                    if(schoolDoc.exists){
                        let school=schoolDoc.data();
                        school.id=schoolDoc.id;
                        school.ref=schoolDoc.ref;
                        this.school=school
                        
                        if(this.sectorId!=null){
                            var sectorDoc=await fb.db.doc('schools/'+this.schoolId+'/sectors/'+this.sectorId).get();
                            if(sectorDoc.exists){
                                let sector=sectorDoc.data();
                                sector.id=sectorDoc.id;
                                sector.ref=sectorDoc.ref;
                                this.sector=sector
                            }
                        }
                    } 
                }  
                else{
                    console.log('dddd');
                }
            },
    
            async getSekzdata(){
                var _this=this;
                var docs=fb.db.collection("schools/"+this.schoolId+"/sectors").get().then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        let object=doc.data();
                        object.id = doc.id;
                        console.log(_this.sekzList);
                        _this.sekzList.push(object);
                    });
                });
            },
        },
        props: {
            schoolId:{
                requered:true
            },
            sectorId:{
                requered:true
            },
        },
        created() {
            var _this=this; 
            this._getData();
        },
        filters: {
            formatDate(val) {
                if (!val) { return '-' }
                let date = val.toDate()
                return moment(date).fromNow()
            },
            trimLength(val) {
                if (val.length < 200) { return val }
                return `${val.substring(0, 200)}...`
            }
        }
    }
</script>

<style scoped>
.numberIsNOTGiven{
    background-color: #ED3D63!important;
    color:white!important;
}
.numberIsGiven{
    background-color: green!important;
    color:white!important;
}
</style>